import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatMap, map, catchError, of } from "rxjs";
import { InterestRateClient } from "src/api-service";
import { InterestRatesActions } from "./interest-rates.actions";
import { DataInterestRatesActions } from "../../../../application/data/interest-rate/interest-rates/interest-rates.actions";
import { normalizeError } from "../../../../app-store-error.types";

@Injectable()
export class InterestRatesEffects {
    private readonly actions$ = inject(Actions);
    private readonly interestRateClient = inject(InterestRateClient);

    updateInterestRate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InterestRatesActions.updateInterestRate),
            concatMap(({ request }) =>
                this.interestRateClient.update(request.key, { ...request }).pipe(
                    map(() =>
                        InterestRatesActions.updateInterestRateSuccess({
                            toastKey: "ADMIN_PANEL.EDIT_INTEREST.TOAST.UPDATE_SUCCESS",
                        }),
                    ),
                    catchError(error =>
                        of(
                            InterestRatesActions.updateInterestRateFailure({
                                error: normalizeError(error),
                                toastKey: "ADMIN_PANEL.EDIT_INTEREST.TOAST.UPDATE_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    // Reload global interest rates store after successful update
    reloadInterestRatesAfterUpdate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InterestRatesActions.updateInterestRateSuccess),
            map(() => DataInterestRatesActions.load()),
        ),
    );
}
